














































































































import {Component, Vue, Prop, Mixins} from 'vue-property-decorator';
import Mixin from './Mixin.vue';

@Component({
  name: 'ProductCard'
})
export default class Default extends Mixins(Mixin) {
}
